import * as React from 'react';
import { IStringLocalizer } from '../../utilities/IStringLocalizer';
import {
    SurveyResponseSubmittedOfflineImportUnavailableMessage
} from '../../store/StateControllers/Survey/SurveyResponse/SurveyResponseModels';
import { ToxnotReactModal, ToxnotReactModalBody, ToxnotReactModalFooter } from '../core/ToxnotReactModal';

export const SurveyResponseSubmittedOfflineImportUnavailableModalId = "survey-response-submitted-offline-import-unavailable-modal";

export const showSurveyResponseSubmittedOfflineImportUnavailablePopup = (): boolean => {
    const $modal = $(`#${SurveyResponseSubmittedOfflineImportUnavailableModalId}`);

    if ($modal.length === 0) {
        return false;
    }

    $modal.modal("show");
    return true;
};

interface SurveyResponseSubmittedOfflineImportUnavailableModalProps {
    localizer: IStringLocalizer;
}

const SurveyResponseSubmittedOfflineImportUnavailableModal: React.FC<SurveyResponseSubmittedOfflineImportUnavailableModalProps> = ({
    localizer
}) => (
    <ToxnotReactModal
        modalId={SurveyResponseSubmittedOfflineImportUnavailableModalId}
        localizedTitle={localizer.localizeString("Offline Import Unavailable")}
    >
        <ToxnotReactModalBody>
            <p>{localizer.localizeString(SurveyResponseSubmittedOfflineImportUnavailableMessage)}</p>
        </ToxnotReactModalBody>
        <ToxnotReactModalFooter
            localizer={localizer}
            customCloseButtonName={localizer.localizeString("Close")}
        />
    </ToxnotReactModal>
);

export default SurveyResponseSubmittedOfflineImportUnavailableModal;
